import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
export interface DialogData {
  user_id: string,
  invoice_id: string,
  pay_Amount: number,
  refunded_Amount: number,
  transactions: any
}
@Component({
  selector: 'app-payment-refund',
  templateUrl: './payment-refund.component.html',
  styleUrls: ['./payment-refund.component.css']
})
export class PaymentRefundComponent implements OnInit {
  paymentRefund: FormGroup;
  public result = "";
  public loading: false;
  public isConnectQBO:boolean = false;
  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<PaymentRefundComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService) {
      this.isConnectQBO = this.CommonService.getIsConnectQBO();

  }

  ngOnInit() {
    this.paymentRefund = this.formBuilder.group({
      refund_amount: [null, Validators.required]
    });
    let balanceAmount = this.numRoundToPlace(Number(this.data.pay_Amount) - Number(this.data.refunded_Amount),2);
    if (balanceAmount && balanceAmount > 0) {
      this.paymentRefund = this.formBuilder.group({
        refund_amount: [null, Validators.compose([Validators.required, Validators.maxLength(balanceAmount)])]
      });
    }

    this.paymentRefund.setValue({
      'refund_amount': balanceAmount
    });

  }
  numRoundToPlace(num, dec) {

    if ((typeof num !== 'number') || (typeof dec !== 'number'))
      return num;

    var num_sign = num >= 0 ? 1 : -1;

    return (Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec);
  }


  isFieldValid(field: string) {
    return (
      !this.paymentRefund.get(field).valid &&
      this.paymentRefund.get(field).touched
    );
  }

  invoicePaymentRefund = function (postData) {
    this.loading=true;
    let refundOptions = {
      id: this.data.user_id,
      invoice_id: this.data.invoice_id,
      amount: postData.refund_amount
    };
    this.CommonService.apiService(
      "POST",
      "invoice/refund",
      refundOptions
    ).subscribe(
      (response: any) => {
        this.loading=false;
        if (response.status === true) {

          if (this.isConnectQBO) {
            this.syncInvoiceRefund(this.data.user_id, this.data.invoice_id, postData.refund_amount);
          }

          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 2000
          });            
          this.result = "success";
          this.dialogRef.close(this.result);
        }
        window.scrollTo(0, 0);
      },
      err => {
        this.loading=false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 2000
        });
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close(this.result);
  }
  
  removeString(transId, type) {
    let chequNo = type == 'Cheque' ? '(Check No: ' + transId.replace('Cheque_', '') + ')' : '';
    return chequNo;
  }

  syncInvoiceRefund = function (id, invoiceId, amount) {
    this.options = {
      id: id,
      invoice_id: invoiceId,
      amount: amount,
      paymentMethod: 'Source Account'
    };
    this.CommonService.apiService(
      "POST",
      "qbo/syncInvoiceRefund",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {

          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 5000
          });

        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/payment-refund/payment-refund.component.ts